// Base URL for the worker API
export const API_URL = 'https://multichannel-ai-integration.techspawn.workers.dev/api';
export const DASHBOARD_URL = 'https://multichannel-ai-integration.techspawn.workers.dev/api/dashboard';

// Chart colors
export const CHART_COLORS = {
  whatsapp: '#25D366',
  telegram: '#0088cc',
  primary: '#4e73df',
  success: '#1cc88a',
  info: '#36b9cc',
  warning: '#f6c23e',
  danger: '#e74a3b'
};

// Debug mode for development
export const DEBUG_MODE = process.env.NODE_ENV === 'development';

// WebSocket URL (if needed)
export const WS_URL = 'wss://multichannel-ai-integration.techspawn.workers.dev/ws';

// Default pagination settings
export const DEFAULT_PAGE_SIZE = 10;
export const MAX_PAGE_SIZE = 100;

// Message polling interval (milliseconds)
export const MESSAGE_POLL_INTERVAL = 3000;

// Chart.js configuration
export const CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        precision: 0
      }
    }
  }
};
